<template>
  <div class="gestion-bodega-institucion-wrapper">
    <!-- Sección de búsqueda -->
    <vs-row class="mt-3">
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
        <div class="search-container">
          <!-- Radio buttons simples arriba -->
          <div class="search-type-radios mb-3">
            <label class="radio-option">
              <input type="radio" v-model="tipoBusqueda" value="documento" name="tipoBusqueda" />
              <span class="radio-label">
                <i class="fa fa-file-text-o"></i>
                Buscar por documento
              </span>
            </label>
            <label class="radio-option">
              <input type="radio" v-model="tipoBusqueda" value="institucion" name="tipoBusqueda" />
              <span class="radio-label">
                <i class="fa fa-building-o"></i>
                Buscar por institución
              </span>
            </label>
          </div>

          <div class="search-input-wrapper">
            <label class="search-label">
              <i :class="tipoBusqueda === 'institucion' ? 'fa fa-building-o' : 'fa fa-file-text-o'"></i>
              {{ tipoBusqueda === 'institucion' ? 'Búsqueda de la institución' : 'Búsqueda del documento de venta' }}
            </label>
            <div class="input-with-button">
              <vs-input
                icon="search"
                class="search-input-field"
                :placeholder="tipoBusqueda === 'institucion' ? 'Ej: Unidad Educativa...' : 'Ej: PF-GC26-C26-ASWNM-1831'"
                @keyup.enter="tipoBusqueda === 'institucion' ? buscarInstitucion() : buscarDocumento()"
                v-model="busqueda" />
              <vs-button
                class="search-button-inline"
                @click="tipoBusqueda === 'institucion' ? buscarInstitucion() : buscarDocumento()"
                type="gradient"
                color="primary">
                <i class="fa fa-search"></i>
                Buscar
              </vs-button>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- Card de institución asignada compacta -->
    <vs-row v-if="institucionAsignada || institucionData.nombreInstitucion" class="mb-4 mt-4">
      <vs-col vs-justify="left" vs-align="left" vs-w="12" vs-sm="12" vs-xs="12" vs-class="w-full">
        <div class="institucion-asignada-card-compacta">
          <!-- Header con institución y botón limpiar -->
          <div class="institucion-header-compacta">
            <div class="institucion-info-compacta">
              <i class="fa fa-check-circle institucion-icon"></i>
              <div>
                <p class="institucion-label">Institución asignada</p>
                <h3 class="institucion-nombre">{{ displayNombreInstitucion }}</h3>
                <p class="institucion-periodo">
                  <i class="fa fa-calendar"></i>
                  Período: <span class="periodo-text">{{ displayPeriodoDescripcion }}</span>
                </p>
              </div>
            </div>
            <vs-button
              color="danger"
              class="delete-button"
              @click="limpiarInstitucion()"
              type="flat"
              icon="delete">
              Limpiar
            </vs-button>
          </div>

          <!-- Información adicional compactada -->
          <div class="info-compacta-grid">
            <!-- Tipo de venta -->
            <div v-if="radioRegalado!=4" class="info-item">
              <label class="info-label">
                <i class="fa fa-tag"></i>
                Tipo de venta:
              </label>
              <div class="info-value">
                <div v-if="displayVentaEstado == 1" class="status-chip success">
                  <span class="status-dot-small"></span>
                  Venta directa
                </div>
                <div v-else-if="displayVentaEstado == 2" class="status-chip primary">
                  <span class="status-dot-small"></span>
                  Venta lista
                </div>
                <div v-else class="status-chip warning">
                  <span class="status-dot-small"></span>
                  No seleccionado
                </div>
              </div>
            </div>

            <!-- Empresa -->
            <div class="info-item">
              <label class="info-label">
                <i class="fa fa-building"></i>
                Empresa:
              </label>
              <div class="info-value">
                <span v-if="displayEmpresa && arrayEmpresas.find(p => p.id == displayEmpresa)">
                  {{ arrayEmpresas.find(p => p.id == displayEmpresa).nombre }}
                </span>
                <span v-else class="text-muted">No seleccionada</span>
              </div>
            </div>

            <!-- Documento -->
            <div class="info-item">
              <label class="info-label">
                <i class="fa fa-file-text-o"></i>
                Documento:
              </label>
              <div class="info-value">
                <span v-if="displayDocumento" class="documento-badge">
                  {{ displayDocumento }}
                </span>
                <span v-else class="text-muted">No seleccionado</span>
              </div>
            </div>

            <!-- Pedido Perseo -->
            <div class="info-item">
              <label class="info-label">
                <i class="fa fa-shopping-cart"></i>
                Pedido Perseo:
              </label>
              <div class="info-value">
                <div v-if="displayPedidoCodigo" class="status-chip info-perseo">
                  <span class="status-dot-small"></span>
                  {{ displayPedidoCodigo }}
                </div>
                <div v-else class="status-chip danger-perseo">
                  <span class="status-dot-small"></span>
                  No tiene
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- Comentario debajo del card -->
    <vs-row v-if="institucionAsignada" class="mt-3">
      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
        <div class="comentario-container-simple">
          <label class="comentario-label-simple">
            <i class="fa fa-comment-o"></i>
            Ingrese comentario:
          </label>
          <vs-input
            icon="icon-message-square"
            class="comentario-input-simple"
            icon-pack="feather"
            placeholder="Escriba un comentario sobre esta importación..."
            v-model="observacion"
            @input="$emit('update:observacion', observacion)"/>
        </div>
      </vs-col>
    </vs-row>

    <!-- Tabla de resultados -->
    <vs-row v-if="instituciones.length > 0">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-5" style="flex-wrap:wrap;" v-if="userRoot && tipoBusqueda === 'institucion'">
        <small>Seleccione un período</small>
        <v-select :options="arrayPeriodos" @input="cambiarPeriodo()" :reduce="arrayPeriodos => arrayPeriodos" label="periodoescolar" class="w-full" v-model="periodoSelect" />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-table stripe max-items="50" style="width: 100%;" search pagination :data="instituciones">
          <template slot="header">
            <div class="vx-row">
              <div class="vx-col w-full m-3">
                Cantidad: {{instituciones.length}}
              </div>
            </div>
          </template>
          <template slot="thead">
            <vs-th v-if="tipoBusqueda === 'institucion'" sort-key="idInstitucion" style="width: 20%;">#</vs-th>
            <vs-th v-if="tipoBusqueda === 'documento'" sort-key="ven_codigo" style="width: 25%;">Documento</vs-th>
            <vs-th sort-key="nombreInstitucion" style="width: 40%;">Institución</vs-th>
            <vs-th v-if="tipoBusqueda === 'documento'" sort-key="id_empresa" style="width: 15%;">Empresa</vs-th>
            <vs-th sort-key="nombre" style="width: 20%;">Localidad</vs-th>
            <vs-th sort-key="nombre" style="width: 20%;">Periodo</vs-th>
            <vs-th v-if="tipoBusqueda === 'documento'" sort-key="tip_ven_codigo" style="width: 15%;">Tipo Venta</vs-th>
            <vs-th sort-key="nombre" style="width: 20%;">Acción</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td v-if="tipoBusqueda === 'institucion'" :data="data[indextr].idInstitucion">
                {{data[indextr].idInstitucion}}
              </vs-td>
              <vs-td v-if="tipoBusqueda === 'documento'" :data="data[indextr].ven_codigo">
                <b>{{data[indextr].ven_codigo}}</b>
              </vs-td>
              <vs-td :data="data[indextr].nombreInstitucion">
                {{data[indextr].nombreInstitucion}}<br>
                <p v-if="tipoBusqueda === 'institucion'"><b>Ruc:</b> {{ tr.ruc }}</p>
                <p v-if="tipoBusqueda === 'institucion'"><b>Teléfono:</b> {{ tr.telefonoInstitucion }}</p>
                <div v-if="tipoBusqueda === 'institucion' && data[indextr].nombre_asesor == null && data[indextr].apellido_asesor == null">
                  <small><i style="color:red;">No existe asesor</i></small><br>
                </div>
                <div v-else-if="tipoBusqueda === 'institucion'">
                  <small><i>{{data[indextr].nombre_asesor}} {{data[indextr].apellido_asesor}}</i></small><br>
                </div>
                <small v-if="tipoBusqueda === 'institucion'">{{data[indextr].fecha_registro}}</small>
              </vs-td>
              <vs-td v-if="tipoBusqueda === 'documento'" :data="data[indextr].id_empresa">
                <span v-if="data[indextr].id_empresa == 1">Prolipa</span>
                <span v-else-if="data[indextr].id_empresa == 3">Calmed</span>
                <span v-else-if="data[indextr].id_empresa == 4">Grupocalmed 2026</span>
                <span v-else>Empresa {{ data[indextr].id_empresa }}</span>
              </vs-td>
              <vs-td :data="tipoBusqueda === 'institucion' ? data[indextr].nombreregion : data[indextr].ciudad">
                {{tipoBusqueda === 'institucion' ? data[indextr].nombreregion : data[indextr].ciudad}}<br>
                <small v-if="tipoBusqueda === 'institucion'">{{data[indextr].ciudad}}</small>
              </vs-td>
              <vs-td>
                <div v-if="tipoBusqueda === 'institucion' && tr.EstadoConfiguracion == 1">
                  {{ tr.periodoNombreConfigurado }}
                  <p class="font-medium" style="color:#ff5733;">
                    Se tomará un periodo activo de la lista de periodos escolares asignados a bodega.
                  </p>
                </div>
                <div v-else>
                  <small>{{ tr.periodo }}</small><br>
                  <vs-chip v-if="tr.statusPeriodo == '1'" color="success" style="margin-left:-5px;">
                    {{ tipoBusqueda === 'institucion' ? tr.estadoPeriodo : 'Activo' }}
                  </vs-chip>
                  <vs-chip v-else color="danger" style="margin-left:-5px;">
                    {{ tipoBusqueda === 'institucion' ? tr.estadoPeriodo : 'Inactivo' }}
                  </vs-chip>
                </div>
              </vs-td>
              <vs-td v-if="tipoBusqueda === 'documento'" :data="data[indextr].tip_ven_codigo">
                <vs-chip v-if="data[indextr].tip_ven_codigo == 1" color="success">Venta directa</vs-chip>
                <vs-chip v-else-if="data[indextr].tip_ven_codigo == 2" color="primary">Venta lista</vs-chip>
                <vs-chip v-else color="warning">No definido</vs-chip>
              </vs-td>
              <vs-td>
                <vs-button v-if="tipoBusqueda === 'institucion'" type="relief" size="small" @click="asignarInstitucion(tr)">
                  Asignar Institución
                </vs-button>
                <vs-button v-else type="relief" size="small" @click="asignarDocumento(tr)">
                  Asignar Documento
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'GestionBodegaInstitucion',
  components: {
    vSelect
  },
  props: {
    arrayPeriodos: {
      type: Array,
      default: () => []
    },
    arrayEmpresas: {
      type: Array,
      default: () => []
    },
    radioRegalado: {
      type: [String, Number],
      default: '0'
    },
    institucionData: {
      type: Object,
      default: () => ({
        nombreInstitucion: '',
        periodoDescripcion: '',
        venta_estado: 0,
        empresa: '',
        documento: '',
        pedido_codigo: null
      })
    }
  },
  data() {
    return {
      tipoBusqueda: 'documento',
      busqueda: '',
      instituciones: [],
      institucionAsignada: null,
      periodoSelect: '',
      observacion: ''
    }
  },
  computed: {
    ...mapState(['userRoot']),
    displayNombreInstitucion() {
      return this.institucionData.nombreInstitucion || (this.institucionAsignada ? this.institucionAsignada.nombreInstitucion : '')
    },
    displayPeriodoDescripcion() {
      return this.institucionData.periodoDescripcion || (this.institucionAsignada ? this.institucionAsignada.periodoDescripcion : '')
    },
    displayVentaEstado() {
      return this.institucionData.venta_estado || (this.institucionAsignada ? this.institucionAsignada.venta_estado : 0)
    },
    displayEmpresa() {
      return this.institucionData.empresa || (this.institucionAsignada ? this.institucionAsignada.empresa : '')
    },
    displayDocumento() {
      return this.institucionData.documento || (this.institucionAsignada ? this.institucionAsignada.documento : '')
    },
    displayPedidoCodigo() {
      return this.institucionData.pedido_codigo || (this.institucionAsignada ? this.institucionAsignada.pedido_codigo : null)
    }
  },
  watch: {
    tipoBusqueda(newValue, oldValue) {
      if (newValue !== oldValue) {
        console.log('Cambio de tipo de búsqueda:', oldValue, '->', newValue)

        // Limpiar todo en el componente hijo
        this.busqueda = ''
        this.institucionAsignada = null
        this.instituciones = []
        this.observacion = ''

        // Emitir evento al padre para que también limpie
        this.$emit('institucion-limpiada')

        // Emitir evento específico para resetear activeTypes
        this.$emit('tipo-busqueda-cambiado')

        console.log('Eventos institucion-limpiada y tipo-busqueda-cambiado emitidos')

        this.$vs.notify({
          text: 'Filtro cambiado. Toda la información ha sido limpiada.',
          color: 'primary',
          iconPack: 'feather',
          icon: 'icon-info'
        })
      }
    },
    // Watcher para sincronizar observacion desde el padre
    'institucionData.nombreInstitucion'(newValue) {
      // Si el padre limpia la institución, también limpiar observacion
      if (!newValue || newValue === '') {
        this.observacion = ''
      }
    }
  },
  methods: {
    buscarInstitucion() {
      let me = this
      me.limpiarInstitucion()

      if (me.busqueda.length < 5) {
        me.$vs.notify({
          text: 'Mínimo 5 caracteres de búsqueda',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-check'
        })
        return false
      }

      me.$vs.loading()
      this.$http.get(this.$server_url + 'listaInsitucion?busqueda=' + me.busqueda)
        .then(function (res) {
          me.instituciones = res.data
          me.$vs.loading.close()
          if (res.data.message) {
            me.$vs.notify({
              text: res.data.message,
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-user'
            })
          }
        })
        .catch(function (error) {
          console.log(error + ' error')
          me.$vs.loading.close()
        })
    },
    buscarDocumento() {
      let me = this
      me.limpiarInstitucion()

      if (me.busqueda.length < 3) {
        me.$vs.notify({
          text: 'Mínimo 3 caracteres de búsqueda',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-check'
        })
        return false
      }

      me.$vs.loading()
      this.$http.get(this.$server_url + 'devoluciones?buscarDocumentoVenta=1&documento=' + me.busqueda)
        .then(function (res) {
          let datos = res.data

          if (datos.length === 0) {
            me.$vs.notify({
              text: 'No se encontraron documentos con ese criterio',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-triangle'
            })
            me.$vs.loading.close()
            return
          }

          me.instituciones = datos
          me.$vs.notify({
            text: `Se encontraron ${datos.length} documento(s)`,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          me.$vs.loading.close()
        })
        .catch(function (error) {
          console.log(error)
          me.$vs.loading.close()
        })
    },
    asignarInstitucion(institucion) {
      let me = this

      // Determinar qué periodo usar según EstadoConfiguracion
      let periodoId = institucion.periodo_id
      let periodoDesc = institucion.periodo

      if (institucion.EstadoConfiguracion == 1) {
        // Si está configurado, usar periodo_configurado y periodoNombreConfigurado
        periodoId = institucion.periodo_configurado
        periodoDesc = institucion.periodoNombreConfigurado
      }

      me.institucionAsignada = {
        idInstitucion: institucion.idInstitucion,
        nombreInstitucion: institucion.nombreInstitucion,
        periodo_id: periodoId,
        periodoDescripcion: periodoDesc,
        ciudadDescripcion: institucion.ciudad,
        EstadoConfiguracion: institucion.EstadoConfiguracion || 0,
        periodo_configurado: institucion.periodo_configurado || null,
        venta_estado: 0,
        empresa: '',
        documento: '',
        id_institucionPedido: null,
        pedido_codigo: null,
        idtipodoc: null
      }

      me.instituciones = []

      me.$emit('institucion-asignada', me.institucionAsignada)

      me.$vs.notify({
        text: 'Institución asignada correctamente',
        color: 'success',
        iconPack: 'feather',
        icon: 'icon-check'
      })
    },
    asignarDocumento(documento) {
      let me = this
      console.log("documento asignado", documento)
      me.institucionAsignada = {
        idInstitucion: documento.institucion_id || documento.id_institucion,
        nombreInstitucion: documento.nombreInstitucion || documento.ven_concepto_perseo,
        periodo_id: documento.periodo_id,
        periodoDescripcion: documento.periodo,
        ciudadDescripcion: documento.ciudad,
        EstadoConfiguracion: 0,
        periodo_configurado: null,
        venta_estado: documento.tip_ven_codigo,
        empresa: documento.id_empresa,
        documento: documento.ven_codigo,
        id_institucionPedido: documento.id_institucionPedido,
        pedido_codigo: documento.pedido_codigo || null,
        idtipodoc: documento.idtipodoc || null
      }

      me.instituciones = []

      me.$emit('documento-asignado', me.institucionAsignada)

      me.$vs.notify({
        text: 'Documento asignado correctamente',
        color: 'success',
        iconPack: 'feather',
        icon: 'icon-check'
      })
    },
    limpiarInstitucion() {
      this.institucionAsignada = null
      this.instituciones = []
      this.observacion = '' // Limpiar observación en el hijo
      this.$emit('update:observacion', '') // Emitir al padre para sincronizar
      this.$emit('institucion-limpiada')
    },
    limpiarTodo() {
      this.busqueda = ''
      this.limpiarInstitucion()
    },
    cambiarPeriodo() {
      let me = this
      if (me.instituciones.length > 0) {
        me.instituciones.map(function (item) {
          item.EstadoConfiguracion = 1
          item.periodo_configurado = me.periodoSelect.idperiodoescolar
          item.periodoNombreConfigurado = me.periodoSelect.periodoescolar
        })
      }
    }
  }
}
</script>

<style scoped>
/* Wrapper principal */
.gestion-bodega-institucion-wrapper {
  width: 100%;
  max-width: 100%;
}

/* Contenedor de búsqueda */
.search-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  width: 100%;
  max-width: 100%;
}

/* Radio buttons simples */
.search-type-radios {
  display: flex;
  gap: 24px;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #667eea;
}

.radio-label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.radio-option:hover .radio-label {
  color: #667eea;
}

.radio-label i {
  font-size: 16px;
  color: #667eea;
}

.search-input-wrapper {
  margin-top: 16px;
  width: 100%;
}

.search-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label i {
  color: #667eea;
  font-size: 16px;
}

.input-with-button {
  display: flex;
  gap: 12px;
  align-items: stretch;
  width: 100%;
}

.search-input-field {
  flex: 1;
  min-width: 0;
}

.search-input-field >>> .vs-inputx {
  height: 48px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
}

.search-input-field >>> .vs-inputx:focus {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.search-button-inline {
  height: 48px;
  padding: 0 32px;
  font-weight: 600;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-button-inline:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(33, 150, 243, 0.4);
}

/* Card compacto de institución */
.institucion-asignada-card-compacta {
  background: linear-gradient(135deg, #5b6f9e 0%, #6b7fa8 100%);
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(91, 111, 158, 0.25);
  width: 100%;
  animation: slideIn 0.4s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.institucion-header-compacta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.institucion-info-compacta {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
}

.institucion-icon {
  font-size: 24px;
  color: #4caf50;
  background: white;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.institucion-label {
  font-size: 10px;
  color: #f5f7fa;
  margin: 0 0 2px 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 600;
}

.institucion-nombre {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 4px 0;
  line-height: 1.2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.institucion-periodo {
  font-size: 11px;
  color: #f5f7fa;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.periodo-text {
  font-weight: 600;
  color: #ffd54f;
}

.delete-button {
  background: rgba(255, 255, 255, 0.15) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  transition: all 0.3s ease !important;
}

.delete-button:hover {
  background: rgba(244, 67, 54, 0.85) !important;
  border-color: #f44336 !important;
  transform: scale(1.03);
}

/* Grid de información */
.info-compacta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  background: transparent;
  padding: 12px;
  border-radius: 8px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 10px;
  color: #f5f7fa;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.info-value {
  font-size: 13px;
  color: #ffffff;
  font-weight: 600;
}

.text-muted {
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
  font-size: 12px;
}

/* Status chips */
.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.status-chip.success {
  background: rgba(76, 175, 80, 0.25);
  border: 1px solid rgba(76, 175, 80, 0.5);
  color: #c8e6c9;
}

.status-chip.primary {
  background: rgba(33, 150, 243, 0.25);
  border: 1px solid rgba(33, 150, 243, 0.5);
  color: #bbdefb;
}

.status-chip.warning {
  background: rgba(255, 152, 0, 0.25);
  border: 1px solid rgba(255, 152, 0, 0.5);
  color: #ffe0b2;
}

.status-dot-small {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-chip.success .status-dot-small {
  background: #81c784;
  box-shadow: 0 0 0 2px rgba(129, 199, 132, 0.3);
}

.status-chip.primary .status-dot-small {
  background: #64b5f6;
  box-shadow: 0 0 0 2px rgba(100, 181, 246, 0.3);
}

.status-chip.warning .status-dot-small {
  background: #ffb74d;
  box-shadow: 0 0 0 2px rgba(255, 183, 77, 0.3);
}

.status-chip.info-perseo {
  background: rgba(33, 150, 243, 0.25);
  border: 1px solid rgba(33, 150, 243, 0.5);
  color: #90caf9;
}

.status-chip.info-perseo .status-dot-small {
  background: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.3);
}

.status-chip.danger-perseo {
  background: rgba(244, 67, 54, 0.25);
  border: 1px solid rgba(244, 67, 54, 0.5);
  color: #ef9a9a;
}

.status-chip.danger-perseo .status-dot-small {
  background: #f44336;
  box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.3);
}

.documento-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: inline-block;
  color: #ffffff;
}

/* Comentario */
.comentario-container-simple {
  background: white;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
  width: 100%;
}

.comentario-container-simple:hover {
  border-color: #7c8db5;
  box-shadow: 0 3px 10px rgba(124, 141, 181, 0.12);
}

.comentario-label-simple {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.comentario-label-simple i {
  color: #7c8db5;
  font-size: 13px;
}

.comentario-input-simple {
  width: 100%;
}

.comentario-input-simple >>> .vs-inputx {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  font-size: 13px;
}

.comentario-input-simple >>> .vs-inputx:focus {
  border-color: #7c8db5;
  box-shadow: 0 0 0 3px rgba(124, 141, 181, 0.08);
}

/* Responsive */
@media (max-width: 768px) {
  .search-type-radios {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .search-container {
    padding: 16px;
  }

  .input-with-button {
    flex-direction: column;
    gap: 12px;
  }

  .search-input-field {
    width: 100%;
  }

  .search-input-field >>> .vs-inputx {
    width: 100%;
  }

  .search-button-inline {
    width: 100%;
    justify-content: center;
    padding: 0 24px;
  }

  .info-compacta-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .institucion-header-compacta {
    flex-direction: column;
    align-items: flex-start;
  }

  .delete-button {
    width: 100%;
  }
}

/* Asegurar que vs-col ocupe 100% */
.gestion-bodega-institucion-wrapper >>> .vs-col {
  width: 100% !important;
  max-width: 100% !important;
}
</style>
